<template>
  <section>
    <PageContent>
      <form @submit.prevent="submit">
        <Container>
          <Headline :level="2">パスワードの変更</Headline>
          <div class="form-group">
            <p class="text-paragraph text-xs">
              パスワードを変更するには、以下の項目を入力してください。
            </p>
          </div>
          <NoticeBox type="error" v-if="hasErrors">
            {{ invalidMessage }}
          </NoticeBox>
          <div class="form-group">
            <label for="password">現在のパスワード</label>
            <input
              id="password"
              type="password"
              class="form-control"
              :class="{ 'has-error': hasError('oldPassword') }"
              v-model="oldPassword"
            />
            <FormError v-if="errors.oldPassword" :errors="errors.oldPassword" />
          </div>
          <div class="form-group">
            <label for="new-password">新しいパスワード</label>
            <input
              id="new-password"
              type="password"
              class="form-control"
              :class="{ 'has-error': hasError('newPassword') }"
              v-model="newPassword"
            />
            <FormError v-if="errors.newPassword" :errors="errors.newPassword" />
            <p class="form-memo rule">8文字以上、半角英小文字と数字を含む</p>
          </div>
          <div class="form-group">
            <label for="new-password-confirm">新しいパスワードを再入力</label>
            <input
              id="new-password-confirm"
              type="password"
              class="form-control"
              :class="{ 'has-error': hasError('newPasswordConfirm') }"
              v-model="newPasswordConfirm"
            />
            <FormError
              v-if="errors.newPasswordConfirm"
              :errors="errors.newPasswordConfirm"
            />
          </div>
          <div class="form-footer text-center">
            <WaveButton type="submit" :loading="loading" :disabled="disabled">
              変更内容を保存する
            </WaveButton>
          </div>
        </Container>
      </form>
    </PageContent>
    <Modal
      id="change-pass"
      title="パスワードの変更が完了しました"
      icon="check"
      @ok="modalOk"
    />
  </section>
</template>

<script>
import { Auth } from 'aws-amplify'
import Modal from '@/components/Modal.vue'
import NoticeBox from '@/components/NoticeBox.vue'
import FormError from '@/components/FormError.vue'
import validationMixin from '@/mixins/validation'
import {
  PASSWORD_MISMATCH,
  PASSWORD_NOT_FOUND,
  PASSWORD_INVALID } from '@/messages/errors'
import { renderError } from '@/utils/error'
import { appRoot } from '@/router'

export default {
  components: {
    Modal,
    NoticeBox,
    FormError
  },
  rules: {
    oldPassword: ['現在のパスワード', ['required']],
    newPassword: ['新しいパスワード', ['required', 'password']],
    newPasswordConfirm: [
      '新しいパスワード（再入力）',
      ['required', ['same', 'newPassword', PASSWORD_MISMATCH]]
    ]
  },
  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'password' }
    }
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      loading: false,
      disabled: false
    }
  },
  methods: {
    async submit() {
      if (this.loading) {
        return false
      }

      if (!this.validate()) {
        window.scrollTo(0, 0)
        return false
      }

      this.loading = true

      try {
        this.newPassword = this.newPassword.trim()
        const user = await Auth.currentAuthenticatedUser()
        await Auth.changePassword(user, this.oldPassword, this.newPassword)
        this.disabled = true
        this.$modal.show('change-pass')
      } catch(err) {
        if (
          err.code === 'NotAuthorizedException' ||
          err.code === 'InvalidParameterException'
        ) {
          this.addValidateError('oldPassword', PASSWORD_NOT_FOUND)
        } else if (err.code === 'InvalidPasswordException') {
          this.addValidateError('newPassword', PASSWORD_INVALID)
        } else {
          renderError(err)
        }

        window.scrollTo(0, 0)
      } finally {
        this.loading = false
      }
    },
    modalOk() {
      appRoot()
    }
  },
  mixins: [validationMixin]
}
</script>
